import React from "react";
import SucursalItem from "./SucursalItem";
import Loader from "@/components/common/Loader";
import Button from "@/components/common/Button";
import { FaPlus } from "react-icons/fa";

/**
 * Componente para mostrar la lista de sucursales
 *
 * @param {Object} props - Propiedades del componente
 * @param {Array} props.sucursales - Lista de sucursales
 * @param {boolean} props.loading - Estado de carga
 * @param {function} props.onEdit - Función para editar una sucursal
 * @param {function} props.onDelete - Función para eliminar una sucursal
 * @param {function} props.onNew - Función para crear una nueva sucursal
 * @returns {JSX.Element} - Componente de lista de sucursales
 */
const SucursalList = ({ sucursales, loading, onEdit, onDelete, onNew }) => {
  if (loading) {
    return (
      <div className="flex justify-center py-6">
        <Loader size="md" color="primary" />
      </div>
    );
  }

  if (sucursales.length === 0) {
    return (
      <div className="text-center py-6">
        <p className="text-gray-400 mb-4">No hay sucursales registradas</p>
        <Button
          variant="primary"
          onClick={onNew}
          className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 rounded"
        >
          <FaPlus className="mr-2" /> Crear Primera Sucursal
        </Button>
      </div>
    );
  }

  return (
    <div>
      {sucursales.map(sucursal => (
        <SucursalItem
          key={sucursal.id}
          sucursal={sucursal}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};

export default SucursalList;
